<style lang="scss" scoped>
  .separator {
    margin: 6em;
  }

  .breadcumb {
    margin: 0 0 1em;
  }

  .meta {
    font-size: 11pt;

    div {
      display: inline-block;

      &:not(:first-child) {
        margin-left: 2em;
      }
    }
  }

  .scoreboard {
    margin: 4em auto 2em;

    table {
      margin: 0 auto;

      thead {
        background-color: #e0f2f1;
        border: 1px solid #222;
        font-size: 14pt;

        th {
          padding: .25em 1em;
          text-align: center;

          &.problem-code {
            border-bottom: 1px solid #222;
            width: 6em;
          }

          &.nim {
            border-right: 1px solid #222;
            width: 16em;
          }

          &.scores {
            border-left: 1px solid #222;
          }
        }
      }

      tbody {
        border: 1px solid #222;
        font-size: 14pt;

        tr {
          &:hover {
            background-color: #c8e6c9;
          }

          &.me {
            background-color: #a5d6a7;
          }

          td {
            padding: .75em 1em;
            text-align: center;

            &.nim {
              border-right: 1px solid #222;
              width: 16em;
            }

            &.scores {
              border-left: 1px solid #222;
            }
          }
        }
      }
    }
  }
</style>

<template>
  <div>
    <NavBar />

    <div class="container">
      <div v-if="assignment">
        <div class="breadcumb">
          <router-link to="/assignments">Assignments</router-link>
          /
          <router-link :to="`/assignments/${assignment.id}`">
            {{ assignment.title }}
          </router-link>
          /
          Scoreboard
        </div>

        <div class="row">
          <div class="col-10">
            <h3>{{ assignment.title }} Scoreboard</h3>
            <div class="meta">
              <div>
                Starts <strong>{{ renderNiceDate(assignment.start_date) }}</strong>
              </div>
              <div>
                Duration
                <strong>{{ getDuration(assignment.start_date, assignment.end_date) }}</strong>
              </div>
            </div>
          </div>
          <div class="col-2" />
        </div>

        <div class="description">
        </div>

        <div class="scoreboard">
          <table border="0">
            <thead>
              <tr>
                <th rowspan="2">Rank</th>
                <th rowspan="2" class="nim">NIM</th>
                <template v-for="problemTitle in Object.keys(mappedProblem)">
                  <th :key="problemTitle" class="problem-code" :title="problemTitle">
                    {{ mappedProblem[problemTitle] }}
                  </th>
                </template>
                <th rowspan="2" class="scores">Scores</th>
              </tr>
              <tr>
                <template v-for="problemTitle in Object.keys(maxScores)">
                  <th :key="problemTitle" class="problem-code" :title="problemTitle">
                    {{ maxScores[problemTitle] }}
                  </th>
                </template>
              </tr>
            </thead>
            <tbody>
              <template v-if="scoreboard.length > 0">
                <template v-for="entry in scoreboard">
                  <tr
                    :key="entry.nim"
                    :class="entry.nim === currentUserNim ? 'me' : ''"
                  >
                    <td>{{ entry.rank }}</td>
                    <td class="nim">{{ entry.nim }}</td>
                    <template v-for="problemTitle in Object.keys(mappedProblem)">
                      <td :key="mappedProblem[problemTitle]" :title="problemTitle">
                        <template v-if="entry.problems[mappedProblem[problemTitle]]">
                          {{ entry.problems[mappedProblem[problemTitle]].scores }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                    </template>
                    <td class="scores">{{ entry.total_scores }}</td>
                  </tr>
                </template>
              </template>
              <template v-else>
                <tr>
                  <td :colspan="3 + Object.keys(mappedProblem).length">
                    No Entry
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDuration, renderNiceDate } from '@/helpers/dateFormatter';
import { fetchApi } from '@/helpers/fetchApi';
import { redirectIfNotLoggedIn } from '@/helpers/loginChecker';

import NavBar from '@/components/NavBar.vue';

async function processAssignmentData(vm) {
  const fetch = fetchApi(vm);
  const assignmentId = vm.$route.params.assignment_id;
  const assignment = await fetch(`/assignments/${assignmentId}`, { withToken: true });

  vm.updateAssignment(assignment.data);
}

async function processScoreboardData(vm) {
  const fetch = fetchApi(vm);
  const assignmentId = vm.$route.params.assignment_id;
  const scoreboard = await fetch(`/assignments/${assignmentId}/scoreboard`, { withToken: true });

  vm.updateScoreboard(scoreboard.data.scoreboard);
  vm.updateMappedProblem(scoreboard.data.mapped_problem);
  vm.updateMaxScores(scoreboard.data.max_scores);
}

export default {
  name: 'scoreboard',
  components: {
    NavBar,
  },
  data: () => ({
    assignment: {},
    scoreboard: [],
    mappedProblem: {},
    maxScores: {},
    currentUserNim: null,
  }),
  methods: {
    getDuration,
    renderNiceDate,

    async updateAssignment(assignment) {
      this.assignment = assignment;

      await this.$nextTick();
    },
    async updateScoreboard(scoreboard) {
      const cleanedScoreboard = scoreboard
        .filter((item) => item.nim !== '0000000000' && item.nim !== '1301160479');

      let rank = 1;
      this.scoreboard = cleanedScoreboard.map((item) => {
        const entry = item;
        entry.rank = rank;

        rank += 1;

        return entry;
      });

      await this.$nextTick();
    },
    async updateMappedProblem(mappedProblem) {
      this.mappedProblem = mappedProblem;

      await this.$nextTick();
    },
    async updateMaxScores(maxScores) {
      this.maxScores = maxScores;

      await this.$nextTick();
    },
  },
  watch: {
    $route: {
      immediate: true,
      async handler() {
        if (await redirectIfNotLoggedIn(this)) {
          return;
        }

        await processAssignmentData(this);
        await processScoreboardData(this);

        this.currentUserNim = await this.$cookies.get('user').nim;
      },
    },
  },
};
</script>
